import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spinner } from '../components/ui/Spinner';
import { useI18nTranslation } from '../lib/use-i18n-translation';
import { useAuth } from './AuthContext';

export const CHANGE_PASSWORD_PATH = '/change-password';

export const ProtectedRoute = () => {
  const { isAuthenticated, isBootstrapping, mustChangePassword } = useAuth();
  const location = useLocation();
  const { t } = useI18nTranslation();

  if (isBootstrapping) {
    return (
      <div className="flex h-full items-center justify-center gap-2 text-muted-foreground">
        <Spinner label={t('app.loading')} />
        <span className="text-sm">{t('app.loading')}</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  // An administrator's reset hands out a one-use password; nothing else in the app opens until it is
  // replaced (plan §2.3). The service refuses every other operation with a 403 while the reset is
  // pending, so this redirect is the courtesy, not the enforcement (plan §11 fix 2).
  if (mustChangePassword && location.pathname !== CHANGE_PASSWORD_PATH) {
    return (
      <Navigate
        to={CHANGE_PASSWORD_PATH}
        replace
      />
    );
  }

  return <Outlet />;
};
